import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"

class ManageLoanCommission extends React.Component {

  componentDidMount() {
    const { params, setCurrentId, loadData, loanCommission } = this.props
    setCurrentId(params.id)
    if(!loanCommission) {
      loadData()
    }
  }

  render() {
    const { loanCommission, callback } = this.props
    return loanCommission ? callback(loanCommission) : <p>Loading ..</p>
  }
}

ManageLoanCommission.propTypes = {
  loanCommission: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const loanCommission = DckSelectors.selectItemById(state, ItemTypes.LoanCommission, ownProps.params.id)
  return { loanCommission }
},

mapDispatchToProps = dispatch => ({
  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.LoanCommission, id)),
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.LoanCommission)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageLoanCommission)



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/ManageItem.js